
const withGlobal = require('with-global');

const $ = require('rgs-jquery');


module.exports = function (callback) {
	return withGlobal({
		$: $,
		jQuery: $,
	}, callback);
};

